export default {
  confirmDialog: undefined,
  messageDialog: undefined,

  tableNameDialog: undefined,
  memberLoginDialog: undefined,
  memberVerificationDialog: undefined,

  checkoutExpiryDialog: undefined,
};
